import React from "react";

// The existing Kanban implementation is kept in the legacy folder during the
// transition, but this resource is intentionally registered as Projects so
// routes, permissions, and saved React Admin state use the canonical name.
const ProjectList = React.lazy(() => import("../deals/DealList"));

export default {
  list: ProjectList,
};
